import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  ValueDuringTimeframe as ValueDuringTimeframeComponent,
  ValueDuringTimeframeProps,
} from "../../components/ValueDuringTimeframe";
import { getMemberTierCustomerAction } from "../../actions";
import { StoreState } from "../../reducers";
import {
  getIsMemberTierLoading,
  getMemberTierCustomer,
} from "../../reducers/methods";

interface ValueDuringTimeframeContainerProps extends ValueDuringTimeframeProps {
  getMemberTierCustomerAction: typeof getMemberTierCustomerAction;
  isLoading: ReturnType<typeof getIsMemberTierLoading>;
  memberTierCustomer: ReturnType<typeof getMemberTierCustomer>;
}

class ValueDuringTimeframe extends React.Component<ValueDuringTimeframeContainerProps> {
  componentDidMount() {
    const isCustomerAuthenticated = get(
      this.props.data,
      "customer.authenticated",
      false
    );

    if (isCustomerAuthenticated && !this.props.isLoading) {
      this.props.getMemberTierCustomerAction();
    }
  }

  render() {
    return <ValueDuringTimeframeComponent {...this.props} />;
  }
}

const mapStateToProp = (state: StoreState) => ({
  isLoading: getIsMemberTierLoading(state),
  memberTierCustomer: getMemberTierCustomer(state),
});

export default connect(mapStateToProp, {
  getMemberTierCustomerAction,
})(ValueDuringTimeframe);
